import {
  Icon,
} from "@abb/abb-common-ux-react";
import {
  ChartTypes,
  DateUnits,
  ISeries,
  ITrendDataLimit,
  Trend,
  TrendMarkerTypes,
} from "@iom/trend";
import _ from "lodash";
import React, { Component } from "react";
import { Translation } from "react-i18next";
import measurementSettingStore from "../../flux/stores/settings/MeasurementSettingStore";
import { Status } from "../../models/sample/Status";
import IThresholdSettings from "../../models/settings/ThresholdSettings";
import * as CONSTANTS from "../../utilities/Constants";
import { ABB_CARET_DOWN, ABB_CARET_UP } from "../../utilities/IconConstants";
import NoTrendToDisplay from "../shared/NoTrendToDisplay";
import utility from "../shared/Utility";
import Utility from "../shared/Utility";
import i18next from "i18next";

interface Iprops {
  startInstrumentMeasurement?: (e: any, sampleId: string) => void;
  stopInstrumentMeasurement?: (e: any, instrumentId: string) => void;
  resumeInstrumentMeasurement?: (e: any, sampleId: string) => void;
  remeasureInstrumentMeasurement?: (e: any, instrumentId: string) => void;
  selectedInstrumentDetail?: any;
  thresholdSettings?: IThresholdSettings[];
  showDashboardDetails: (screen: number) => void;
  showInstrumentPropertyDetails: (data: any) => void;
}

interface IState {
  searchValue: string;
  toggleGraph: boolean;
  chartType: ChartTypes;
  dateUnit: DateUnits;
  dateUnitCount: number;
  series: any;
  start?: Date;
  end?: Date;
  thresholdSettings: IThresholdSettings[];
  activeDirectionIndx: string[];
}

export default class InstrumentProperty extends Component<Iprops, IState> {
  private minXValue: number;
  private maxXValue: number;
  private start = new Date(2019, 0, 1, 0, 0, 0, 0);
  private end = new Date(2019, 0, 5, 0, 0, 0, 0);
  constructor(props: any) {
    super(props);
    this.state = {
      searchValue: "",
      chartType: "Bar",
      dateUnit: "Day",
      thresholdSettings: this.props?.thresholdSettings ?? [],
      start: this.start,
      end: this.end,
      toggleGraph: false,
      dateUnitCount: 4,
      series: [
        {
          name: "Position",
          color: "#5ABFAE",
          id: "1",
          markerStyle: {
            type: this.state?.chartType ==="Bar" ? "None" : "Circle",
          },
          yAxis: {
            min: this.minXValue,
            max: this.maxXValue,
            decimalPlaces: 0,
          },
          isShownInChart: true,
          points: this.generateOrdinalData1(0, 20, 1, 0, 100), // String
        },
      ],
      activeDirectionIndx: []
    };
  }

  private generateOrdinalData1(
    fromDate: number,
    toDate: number,
    interval = 1,
    min: number,
    max: number,
    isNumber = false
  ) {
    const data = [
      {
        xValue: "Position",
        value: 50,
      },
    ];
    return data;
  }


  private createMeasuredDashboard = () => {
    const items: any[] = [];
    const positionData = this.props.selectedInstrumentDetail.countData;

    positionData.forEach((data: any, index: number) => {
      items.push(
        <Translation>
          {(t) => (
            <th
              className="property instrument-roperty-position-header"
              key={index + Math.random()}
              onClick={(e: any) => this.props.showInstrumentPropertyDetails(data)}
            >
              <div className="measureItems">
                <div className="details">
                  <p className="title">{data.positionName}</p>
                  {this.props.selectedInstrumentDetail?.isAutoLine ? (<p className="statusGray">{this.props.selectedInstrumentDetail.status.name}</p>) :
                    data.directions[0].totalCounts && data.directions[0].completedCounts ===
                      data.directions[0].totalCounts ? (
                      <p className="statusGreen">{t(Status.COMPLETED)}</p>
                    ) : (
                      <p className="statusGray">{t(Status.MEASURING)}</p>
                    )}

                  <p>
                    {data.directions[0].completedCounts}(
                    {data.directions[0].totalCounts})
                  </p>
                </div>
                {!this.props.selectedInstrumentDetail?.isAutoLine && (
                  <span className="buttons-in-property-details">
                    <p className="count-numbers">
                      T - {data.directions[0].totalCounts}
                    </p>
                    <p className="count-numbers">
                      C - {data.directions[0]?.completedCounts ?? 0}
                    </p>
                    <p className="count-numbers">
                      S - {data.directions[0]?.skipped ?? 0}
                    </p>
                  </span>
                )}
                <progress
                  value={data.directions[0].completedCounts}
                  max={data.directions[0].totalCounts}
                  className="progressOrange"
                >
                  {" "}
                </progress>
              </div>
            </th>
          )}
        </Translation>
      );
    });

    return <React.Fragment>{items}</React.Fragment>;
  };
  private getRightColorForDashboardView(
    allValueRangesForAPosition: any[]
  ): string {
    let color = CONSTANTS.WITHIN_LIMIT_COLOR;
    if (
      allValueRangesForAPosition?.filter(
        (x) => x?.valueRange?.name === CONSTANTS.ValueRange.AlarmLimit1
      )?.length > 0
    ) {
      color = this.state.thresholdSettings.find(
        (x: any) => x.name === "Alarm Limit1"
      )?.colorCode;
    } else if (
      allValueRangesForAPosition?.filter(
        (x) => x?.valueRange?.name === CONSTANTS.ValueRange.AlarmLimit2
      )?.length > 0
    ) {
      color = this.state.thresholdSettings.find(
        (x: any) => x.name === "Alarm Limit2"
      )?.colorCode;
    } else if (
      allValueRangesForAPosition?.filter(
        (x) => x?.valueRange?.name === CONSTANTS.ValueRange.RejectLimit
      )?.length > 0
    ) {
      color = this.state.thresholdSettings.find(
        (x: any) => x.name === "Reject Limit"
      )?.colorCode;
    }
    return color;
  }

  private onSetActiveDirectionIndx = (id: string) => {
    const activeDirectionIndx = [...this.state.activeDirectionIndx];
    if (activeDirectionIndx.includes(id.toString().trim())) {
      const index = activeDirectionIndx.indexOf(id);
      if (index > -1) {
        activeDirectionIndx.splice(index, 1);
      }
    } else {
      activeDirectionIndx.push(id);
    }
    this.setState({ activeDirectionIndx });
  };

  private measuredRow() {
    const items: any[] = [];
    const selectedInstrumentDetail = this.props.selectedInstrumentDetail;
    selectedInstrumentDetail?.allDirections?.sort((a: any, b: any) => { return a.order - b.order });
    const countData = selectedInstrumentDetail.countData.find(
      (x: any) => x.selected
    );
    let selectedDirection: any;
    if (countData !== undefined) {
      selectedDirection = countData.directions.find((x: any) => x.selected);
    }

    if (!selectedDirection) {
      if (countData && countData.directions) {
        selectedDirection = countData.directions[0];
        selectedDirection.selected = true;
      }
    }

    const searchFilter = this.props.selectedInstrumentDetail?.properties?.length
      ? Utility.getUniquePropertiesFromList(
        this.props.selectedInstrumentDetail?.properties
      )
      : [];

    const filteredProps = searchFilter.filter((property) => {
      // search functionality
      return property.name.toLowerCase().includes(this.state.searchValue.toString().toLowerCase());
    });

    if (this.props.selectedInstrumentDetail?.isAutoLine) {
      filteredProps.forEach((property: any, index: any) => {
        let meanV;
        if (selectedInstrumentDetail?.readings?.length > 0) {
          meanV =
            selectedInstrumentDetail.readings[0].directionMeans !==
              undefined
              ? selectedInstrumentDetail.readings[0].directionMeans.find(
                (x: any) =>
                  x.propertyId === property.id &&
                  x.directionId === property.directionId
              )
              : undefined;
        }
        const dirCount =
          this.props.selectedInstrumentDetail.directionCounts.find(
            (x: any) => x.name === countData?.positionName
          );
        var allValueRangesForAPosition: any[] = [];
        this.props.selectedInstrumentDetail.readings.forEach((x: any) => {
          if (dirCount !== undefined) {
            if (
              x.propertyId === property.id &&
              x.positionName === dirCount.name &&
              x.position === index
            ) {
              allValueRangesForAPosition.push(x);
            }
          }
        });

        var color = this.getRightColorForDashboardView(
          allValueRangesForAPosition
        );
        const meanVal = (meanV === undefined || meanV.mean === 0) ? "(--)" : meanV.mean;
        const meanValue = Math.round(Number(meanVal) * 100) / 100;

        let statisticsMeans: any[] = [];
        if (
          selectedInstrumentDetail.statistics &&
          selectedInstrumentDetail.statistics.length
        ) {
          const DatalistStatistics =
            selectedInstrumentDetail.statistics.filter((el: any) => {
              return (
                el.propertyId === property.id &&
                el.directionId === property.directionId
              );
            });
          statisticsMeans = _.sortBy(DatalistStatistics, "position");
        }
        items.push(
          <tr
            key={index}
          >
            <td className="instrument" style={{ padding: "0px" }}>
              <table className="innerTable ins-mesurement">
                <tr style={{ background: "none" }}>
                  <td className="title">
                    <span className="row pl-0 pr-0">
                      <span className="col-7 pl-0 ">{property.name}</span>
                      <span className="col-1 pl-0">{property.unit}</span>
                      <span className="col-4 pl-0">
                        {isNaN(meanValue) || meanValue === null || meanValue === undefined ? (
                          <span
                            className="val"
                            style={{
                              color: CONSTANTS.WITHIN_LIMIT_COLOR
                            }}
                          >
                            {CONSTANTS.NOTCONSIDEREDFORCALC}
                          </span>
                        ) : (
                          <span
                            className="val"
                            style={{
                              color: CONSTANTS.WITHIN_LIMIT_COLOR
                            }}
                          >
                            ({meanValue?.toFixed(property?.decimals)})
                          </span>
                        )}
                      </span>
                    </span>
                  </td>
                </tr>
              </table>
            </td>
            {this.props.selectedInstrumentDetail.countData.length &&
              this.props.selectedInstrumentDetail.countData.map(
                (el: any, indexNumber: number) => {
                  const MeanObject = (statisticsMeans || []).find(
                    (elements: any) =>
                      elements.propertyId === property.id &&
                      elements.directionId === property.directionId &&
                      elements.position === indexNumber
                  );
                  if (MeanObject) {
                    return (
                      <td className="property val">
                        <span>
                          {!isNaN(MeanObject.mean) && MeanObject.mean !== null && MeanObject.mean !== undefined
                            ? `(${MeanObject?.mean?.toFixed(
                              property?.decimals
                            )})`
                            : CONSTANTS.NOTCONSIDEREDFORCALC}
                        </span>
                      </td>
                    );
                  } else {
                    return (
                      <td className="property val">
                        <span> {CONSTANTS.NOTCONSIDEREDFORCALC}</span>
                      </td>
                    );
                  }
                }
              )}
          </tr>
        );
      });
    } else {
      selectedInstrumentDetail.allDirections.forEach((elems: any, key: number) => {
        items.push(
          <React.Fragment>
            <br />
            <span
              style={{
                cursor: "pointer",
                fontWeight:
                  this.state.activeDirectionIndx.includes(elems.id)
                    ? "bold"
                    : "normal",
                fontSize:
                  this.state.activeDirectionIndx.includes(elems.id) ? "16px" : "14px",
              }}
              id="directionRow"
              onClick={() => this.onSetActiveDirectionIndx(elems.id)}
            >
              {this.state.activeDirectionIndx.includes(elems.id) ? (
                <Icon className="mr-3" name={ABB_CARET_DOWN} />
              ) : (
                <Icon className="mr-3" name={ABB_CARET_UP} />
              )}
              <b style={{ marginRight: "10px" }}>{elems.name}</b>
            </span>
          </React.Fragment>
        );
        let newrow = key;
        let filteredPropsData = filteredProps.filter(
          (elements: any) => elements.directionId === elems.id
        );
        this.state.activeDirectionIndx.includes(elems.id) &&
          (filteredPropsData || []).forEach((property: any, index: any) => {
            let meanV;
            if (selectedInstrumentDetail?.readings?.length > 0) {
              const filterReadings = selectedInstrumentDetail.readings.find((x: any) => x.propertyId === property.id &&
                x.directionId === property.directionId);
              meanV = filterReadings
                ? filterReadings.directionMeans.find(
                  (x: any) =>
                    x.propertyId === property.id &&
                    x.directionId === property.directionId
                )
                : undefined;
            }
            const dirCount =
              this.props.selectedInstrumentDetail.directionCounts.find(
                (x: any) => x.name === countData?.positionName
              );
            var allValueRangesForAPosition: any[] = [];
            this.props.selectedInstrumentDetail.readings.forEach((x: any) => {
              if (dirCount !== undefined) {
                if (
                  x.propertyId === property.id &&
                  x.positionName === dirCount.name &&
                  x.position === index
                ) {
                  allValueRangesForAPosition.push(x);
                }
              }
            });

            var color = this.getRightColorForDashboardView(
              allValueRangesForAPosition
            );
            const meanVal = (meanV === undefined || meanV.mean === 0) ? "(--)" : meanV.mean;
            const meanValue = Math.round(Number(meanVal) * 100) / 100;

            let statisticsMeans: any[] = [];
            if (
              selectedInstrumentDetail.statistics &&
              selectedInstrumentDetail.statistics.length
            ) {
              const DatalistStatistics =
                selectedInstrumentDetail.statistics.filter((el: any) => {
                  return (
                    el.propertyId === property.id &&
                    el.directionId === property.directionId
                  );
                });
              statisticsMeans = _.sortBy(DatalistStatistics, "position");
            }
            items.push(
              <tr
                key={key + "-" + index}
                style={key === newrow ? { borderTop: "2px solid #1f1f1f" } : {}}
              >
                <td className="instrument" style={{ padding: "0px" }}>
                  <table className="innerTable ins-mesurement">
                    <tr style={{ background: "none" }}>
                      <td className="title">
                        <span className="row pl-0 pr-0">
                          <span className="col-7 pl-0 ">{property.name}</span>
                          <span className="col-1 pl-0">{property.unit}</span>
                          <span className="col-4 pl-0">
                            {isNaN(meanValue) || meanValue === null || meanValue === undefined ? (
                              <span
                                className="val"
                                style={{
                                  color: CONSTANTS.WITHIN_LIMIT_COLOR
                                }}
                              >
                                {CONSTANTS.NOTCONSIDEREDFORCALC}
                              </span>
                            ) : (
                              <span
                                className="val"
                                style={{
                                  color: CONSTANTS.WITHIN_LIMIT_COLOR
                                }}
                              >
                                ({meanValue?.toFixed(property?.decimals)})
                              </span>
                            )}
                          </span>
                        </span>
                      </td>
                    </tr>
                  </table>
                </td>
                {this.props.selectedInstrumentDetail.countData.length &&
                  this.props.selectedInstrumentDetail.countData.map(
                    (el: any, indexNumber: number) => {
                      const MeanObject = (statisticsMeans || []).find(
                        (elements: any) =>
                          elements.propertyId === property.id &&
                          elements.directionId === property.directionId &&
                          elements.position === indexNumber
                      );

                      let secondaryClassName: string = "";

                      let isActiveIndication: boolean = false;

                      if (
                        this.props.selectedInstrumentDetail &&
                        this.props.selectedInstrumentDetail
                          .nextMeasuringPositionDireaction &&
                        this.props.selectedInstrumentDetail
                          .nextMeasuringPositionDireaction.position ===
                        indexNumber &&
                        this.props.selectedInstrumentDetail
                          .nextMeasuringPositionDireaction.directionId ===
                        elems.id
                      ) {
                        isActiveIndication = true;
                        if (index === 0) {
                          secondaryClassName = "border-top-box";
                        } else if (
                          (filteredPropsData || []).length ===
                          index + 1
                        ) {
                          secondaryClassName = "border-bottom-box";
                        }
                      }
                      if (MeanObject) {
                        return (
                          <td className={
                            isActiveIndication
                              ? `property val box-border ${secondaryClassName}`
                              : "property val "
                          }>
                            <span>
                              {!isNaN(MeanObject.mean) && MeanObject.mean !== null && MeanObject.mean !== undefined
                                ? `(${MeanObject?.mean?.toFixed(
                                  property?.decimals
                                )})`
                                : CONSTANTS.NOTCONSIDEREDFORCALC}
                            </span>
                          </td>
                        );
                      } else {
                        return (
                          <td className={
                            isActiveIndication
                              ? `property val box-border ${secondaryClassName}`
                              : "property val "
                          }>
                            <span> {CONSTANTS.NOTCONSIDEREDFORCALC}</span>
                          </td>
                        );
                      }
                    }
                  )}
              </tr>
            );
            newrow += 1;
          });
      });
    }
    return items;
  }

  private searchHandler = (e: any) => {
    const value = e.target.value;
    this.setState({
      searchValue: value,
    });
  };


  public createData(
    propertyId: any,
    propertyName: string,
    selectedDirection: any,
    selectedPosition: any,
    directionId?: string,
    cpPosition?: number,
    fulllength?: number,
    currentlength?: number,
    isMeasuring?: boolean
  ) {
    const items: any[] = [];
    if (selectedDirection !== undefined) {
      for (let index = 0; index < selectedDirection?.maxCount; index++) {
        const readings = this.props.selectedInstrumentDetail.readings;
        // properties and directionCounts
        let dirC: any[] = [];
        if (selectedDirection.name === "All") {
          dirC = this.props.selectedInstrumentDetail.directionCounts.filter(
            (x: any) =>
              x.position === selectedPosition.position &&
              x.direction.id === directionId
          );
        }
        let indexNumber = 0;
        dirC.forEach((element: any) => {
          const checkDirection = propertyName.search(element.direction.name);
          if (checkDirection !== -1) {
            indexNumber = element.totalCounts;
          }
        });
        let mainData;
        if (readings.length > 0) {
          if (selectedDirection.name === "All") {
            if (this.props.selectedInstrumentDetail.isAutoLine) {
              const countData =
                this.props.selectedInstrumentDetail.countData.find(
                  (x: any) => x.selected === true
                );
              const dirCount =
                this.props.selectedInstrumentDetail.directionCounts.find(
                  (x: any) => x.name === countData?.positionName
                );
              this.props.selectedInstrumentDetail.readings.forEach((x: any) => {
                if (
                  x.propertyId === propertyId &&
                  x.count === index + 1 &&
                  x.position === dirCount.position &&
                  x.positionName === dirCount.name
                ) {
                  mainData = x;
                }
              });
            } else {
              mainData = readings.find(
                (x: any) =>
                  x.count === index + 1 &&
                  x.propertyId === propertyId &&
                  x.position === selectedPosition.position &&
                  x.directionId === directionId
              );
            }
          } else {
            mainData = readings.find(
              (x: any) =>
                x.count === index + 1 &&
                x.propertyId === propertyId &&
                x.directionId === selectedDirection.id &&
                x.position === selectedPosition.position
            );
          }
        }

        const data =
          mainData !== undefined &&
            mainData.value != null &&
            !isNaN(mainData.value)
            ? mainData.value?.toFixed(mainData.decimals)
            : indexNumber <= index
              ? CONSTANTS.NOTCONSIDEREDFORCALC
              : CONSTANTS.NOTCONSIDEREDFORCALC;
        let color = "black";
        if (mainData !== undefined) {
          if (mainData.valueRange.name === "Alarm Limit1") {
            color = this.props.thresholdSettings.find(
              (x: any) => x.name === "Alarm Limit1"
            )?.colorCode;
          } else if (mainData.valueRange.name === "Alarm Limit2") {
            color = this.props.thresholdSettings.find(
              (x: any) => x.name === "Alarm Limit2"
            )?.colorCode;
          } else if (mainData.valueRange.name === "Reject Limit") {
            color = this.props.thresholdSettings.find(
              (x: any) => x.name === "Reject Limit"
            )?.colorCode;
          }
        }

        let pos = this.props.selectedInstrumentDetail.countData.find(
          (x: any) => x.position === selectedPosition.position
        );
        let dir = pos.directions.find((x: any) => x.id === directionId);
        const totalCompletedCounts = dir.completedCounts + (dir?.skipped ?? 0);

        let secondaryClassName: string = "";
        if (currentlength === 0) {
          secondaryClassName = "border-top-box";
        } else if (fulllength === currentlength + 1) {
          secondaryClassName = "border-bottom-box";
        }

        let isActiveIndication: boolean = false;

        if (
          this.props.selectedInstrumentDetail &&
          this.props.selectedInstrumentDetail.nextMeasuringPositionDireaction &&
          this.props.selectedInstrumentDetail.nextMeasuringPositionDireaction
            .directionId === directionId &&
          this.props.selectedInstrumentDetail.nextMeasuringPositionDireaction
            .count ===
          index + 1
        ) {
          isActiveIndication = true;
        }

        items.push(
          <td
            className={
              totalCompletedCounts === index &&
                isActiveIndication &&
                isMeasuring
                ? `normal-class text-align-center col box-border ${secondaryClassName}`
                : `normal-class text-align-center`
            }
            style={{ minWidth: "100px" }}
            key={index}
          >
            <span style={{ color }}>{data}</span>
          </td>
        );
      }
    }

    return items;
  }



  private changeSelectedHandler = (item: any, series: any) => {
    if (this.state.toggleGraph) {
      const thresholdSettings: any[] = [];
      const seriesData = JSON.parse(JSON.stringify(series));
      this.state.thresholdSettings.forEach((element: any, index: any) => {
        if (index === item) {
          element.isActive = !element.isActive;
          thresholdSettings.push(element);
        } else {
          thresholdSettings.push(element);
        }
      });

      this.setState(
        {
          thresholdSettings: thresholdSettings,
          series: seriesData,
        },
        () => {
          console.log(this.state?.series);
        }
      );
    }
  };

  public colorDisplay = () => {
    return (this.state?.thresholdSettings || []).map((th: any, i: number) => {
      return th.key === "RJLT" || th.key === "ALLT2" || th.key === "ALLT1" ? (
        <div
          className={
            th?.isActive
              ? "fl threshold fullopacity"
              : "fl threshold halfopacity"
          }
          key={i}
          onClick={(e) => this.changeSelectedHandler(i, this.state.series)}
        >
          <div
            className="fl threshold-box"
            style={{ background: th?.colorCode }}
          />
          <span className="fl threshold-text">{i18next.t(th?.name)} </span>
        </div>
      ) : (
        ""
      );
    });
  };

  private onChartTypeChange = (chartType: ChartTypes) => {
    this.setState({
      chartType: chartType,
    });
    return chartType;
  };

  private onDataLimitVisibilityChange = (
    series: ISeries,
    limit: ITrendDataLimit,
    isShown: boolean
  ) => {
    let updatedValue = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        let limits = item.dataLimits.map((line: ITrendDataLimit) => {
          if (line.name === limit.name) {
            return { ...line, shownInChart: isShown };
          } else {
            return line;
          }
        });
        return { ...item, dataLimits: limits };
      } else {
        return item;
      }
    });

    this.setState({ series: updatedValue });
  };

  private onDateRangeChange = (
    start: string | number | Date,
    end: string | number | Date,
    dateUnit: DateUnits,
    dateUnitCount: number,
    isOnZoom: boolean
  ) => {
    this.setState({
      dateUnit,
      dateUnitCount,
      start: start as Date,
      end: end as Date,
    });
  };

  private onSeriesChartTypeChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return { ...item, chartType: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  private onSeriesColorChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return { ...item, color: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  private onSeriesFillTypeChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return { ...item, fillType: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  private onSeriesMarkerChange = (value: TrendMarkerTypes, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return {
          ...item,
          markerStyle: { ...series.markerStyle, type: value },
        } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  private onInvalidPointTypeChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return { ...item, invalidPointLineType: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };
  private graphRowDetails() {
    const items: any[] = [];
    const selectedInstrumentDetail = this.props.selectedInstrumentDetail;
    selectedInstrumentDetail?.allDirections?.sort((a: any, b: any) => { return a.order - b.order });
    const countData = selectedInstrumentDetail.countData.find(
      (x: any) => x.selected
    );
    let selectedDirection: any;
    if (countData !== undefined) {
      selectedDirection = countData.directions.find((x: any) => x.selected);
    }
    if (!selectedDirection) {
      selectedDirection = countData.directions[0];
      selectedDirection.selected = true;
    }

    const searchFilter = Utility.getUniquePropertiesFromList(
      this.props.selectedInstrumentDetail.properties
    );

    const filteredProps = searchFilter.filter((property) => {
      // search functionality
      return property.name.toLowerCase().includes(this.state.searchValue.toString().toLowerCase());
    });

    if (this.props.selectedInstrumentDetail?.isAutoLine) {
      filteredProps.forEach((property: any, index: any) => {
        let meanV;
        if (selectedInstrumentDetail?.readings?.length > 0) {
          meanV =
            selectedInstrumentDetail.readings[0].directionMeans !==
              undefined
              ? selectedInstrumentDetail.readings[0].directionMeans.find(
                (x: any) =>
                  x.propertyId === property.id &&
                  x.directionId === property.directionId
              )
              : undefined;
        }
        const dirCount =
          this.props.selectedInstrumentDetail.directionCounts.find(
            (x: any) => x.name === countData?.positionName
          );
        var allValueRangesForAPosition: any[] = [];
        this.props.selectedInstrumentDetail.readings.forEach((x: any) => {
          if (dirCount !== undefined) {
            if (
              x.propertyId === property.id &&
              x.positionName === dirCount.name &&
              x.position === index
            ) {
              allValueRangesForAPosition.push(x);
            }
          }
        });
        const meanVal = (meanV === undefined || meanV.mean === 0) ? "(--)" : meanV.mean;
        const meanValue = Math.round(Number(meanVal) * 100) / 100;

        const trendData = [];
        let propertyDetails: any = {};

        selectedInstrumentDetail?.statistics
          ?.sort(utility.sortAlphaNum)
          .forEach((item: any) => {
            if (
              property.id === item.propertyId &&
              property.directionId === item.directionId
            ) {
              propertyDetails = filteredProps.find(
                (x) => item.propertyId === x.id
              );
              trendData.push({
                xValue: item.positionName
                  ? item.positionName
                  : item.position.toString(),
                value: item.mean != null ? item.mean : 0,
              });
            }
          });
        if (trendData.length !== 0) {
            trendData.push({ xValue: "", value: null });
        }
        const yValue: number[] = [
          propertyDetails.alarmLow1,
          propertyDetails.alarmLow2,
          propertyDetails.alarmHigh1,
          propertyDetails.alarmHigh2,
          propertyDetails.rejectLow,
          propertyDetails.rejectHigh,
        ];
        trendData.sort(utility.sortAlphaNum).forEach((item: any) => {
          yValue.push(item.value);
        });

        let minYValue: any = 0;
        let maxYValue: any = 0;

        if (Math.sign(_.min(yValue)) === -1) {
          minYValue = _.min(yValue) + (_.min(yValue) / 100) * 5;
          maxYValue = _.max(yValue) - (_.max(yValue) / 100) * 5;
        } else {
          // ITC Changes
          minYValue = _.min(yValue) - (_.min(yValue) / 100) * 5;
          // const minYValue: any = 0;
          maxYValue = _.max(yValue) + (_.max(yValue) / 100) * 5;
        }

        const series1: ISeries[] = [
          {
            name: "Mean",
            color: "#5ABFAE",
            id: "1",
            markerStyle: {
              type: this.state?.chartType ==="Bar" ? "None" : "Circle",
            },
            yAxis: {
              min: minYValue,
              max: maxYValue,
              decimalPlaces: propertyDetails?.decimals,
            },
            dataLimits: [
              {
                name: "Alarm Low Limit-1",
                shownInChart: this.state.thresholdSettings?.find(
                  (x: any) =>
                    x.name === "Alarm Low 1" || x.name === "Alarm Limit1"
                ).isActive,
                value: propertyDetails.alarmLow1,
                className: "custom-line-graph",
                style: {
                  stroke: this.state.thresholdSettings?.find(
                    (x: any) =>
                      x.name === "Alarm Low 1" || x.name === "Alarm Limit1"
                  ).colorCode,
                },
              },
              {
                name: "Alarm High Limit-1",
                shownInChart: this.state.thresholdSettings?.find(
                  (x: any) =>
                    x.name === "Alarm High 1" || x.name === "Alarm Limit1"
                ).isActive,
                value: propertyDetails.alarmHigh1,
                className: "custom-line-graph",
                style: {
                  stroke: this.state.thresholdSettings?.find(
                    (x: any) =>
                      x.name === "Alarm High 1" || x.name === "Alarm Limit1"
                  ).colorCode,
                },
              },
              {
                name: "Alarm Low Limit-2",
                shownInChart: this.state.thresholdSettings?.find(
                  (x: any) =>
                    x.name === "Alarm Low 2" || x.name === "Alarm Limit2"
                ).isActive,
                value: propertyDetails.alarmLow2,
                className: "custom-line-graph",
                style: {
                  stroke: this.state.thresholdSettings?.find(
                    (x: any) =>
                      x.name === "Alarm Low 2" || x.name === "Alarm Limit2"
                  ).colorCode,
                },
              },
              {
                name: "Alarm High Limit-2",
                shownInChart: this.state.thresholdSettings?.find(
                  (x: any) =>
                    x.name === "Alarm High 2" || x.name === "Alarm Limit2"
                ).isActive,
                value: propertyDetails.alarmHigh2,
                className: "custom-line-graph",
                style: {
                  stroke: this.state.thresholdSettings?.find(
                    (x: any) =>
                      x.name === "Alarm High 2" || x.name === "Alarm Limit2"
                  ).colorCode,
                },
              },
              {
                name: "Reject Low",
                shownInChart: this.state.thresholdSettings?.find(
                  (x: any) =>
                    x.name === "Reject Low" || x.name === "Reject Limit"
                ).isActive,
                value: propertyDetails.rejectLow,
                className: "custom-line-graph",
                style: {
                  stroke: this.state.thresholdSettings?.find(
                    (x: any) =>
                      x.name === "Reject Low" || x.name === "Reject Limit"
                  ).colorCode,
                },
              },
              {
                name: "Reject High",
                shownInChart: this.state.thresholdSettings?.find(
                  (x: any) =>
                    x.name === "Reject High" || x.name === "Reject Limit"
                ).isActive,
                value: propertyDetails.rejectHigh,
                className: "custom-line-graph",
                style: {
                  stroke: this.state.thresholdSettings?.find(
                    (x: any) =>
                      x.name === "Reject High" || x.name === "Reject Limit"
                  ).colorCode,
                },
              },
            ],
            isShownInChart: true,
            points: trendData,
          },
        ];

        items.push(
          <tr
            key={index}
          >
            <td className="instrument" style={{ padding: "0px" }}>
              <table className="innerTable ins-mesurement">
                <tr style={{ background: "none" }}>
                  <td className="title" style={{ paddingBottom: "114px" }}>
                    <span className="row pl-0 pr-0">
                      <span className="col-7 pl-0">{property.name}</span>
                      <span className="col-1 pl-0">{property.unit}</span>
                      <span className="col-4 pl-0">
                        {isNaN(meanValue) || meanValue === null || meanValue === undefined ? (
                          <span
                            className="val"
                            style={{
                              color: CONSTANTS.WITHIN_LIMIT_COLOR
                            }}
                          >
                            {CONSTANTS.NOTCONSIDEREDFORCALC}
                          </span>
                        ) : (
                          <span
                            className="val"
                            style={{
                              color: CONSTANTS.WITHIN_LIMIT_COLOR
                            }}
                          >
                            ({meanValue?.toFixed(property?.decimals)})
                          </span>
                        )}
                      </span>
                    </span>
                  </td>
                </tr>
              </table>
            </td>
            {
              <td
                className="trend-table"
                colSpan={selectedInstrumentDetail.countData.length}
              >
                {series1[0].points?.length > 0 ? (
                  <Trend
                    chartType={this.state.chartType}
                    invalidPointLineType="None"
                    invalidStatuses={["Invalid"]}
                    dateUnit={this.state.dateUnit}
                    dateUnitCount={this.state.dateUnitCount}
                    gridLineColor="grey"
                    gridLineWidth={0.5}
                    showVerticalGridLines={false}
                    showHorizontalGridLines={true}
                    series={series1}
                    xAxis={{ type: "Ordinal", tickAngle: 45, height: 60 }}
                    onChartTypeChange={this.onChartTypeChange}
                    onDataLimitVisibilityChange={
                      this.onDataLimitVisibilityChange
                    }
                    onDateRangeChange={this.onDateRangeChange}
                    onInvalidPointTypeChange={this.onInvalidPointTypeChange}
                    onSeriesChartTypeChange={this.onSeriesChartTypeChange}
                    onSeriesColorChange={this.onSeriesColorChange}
                    onSeriesFillTypeChange={this.onSeriesFillTypeChange}
                    onSeriesMarkerChange={this.onSeriesMarkerChange}
                    trendChartHeight={150}
                    showChartType={false}
                    showDateTimePicker={false}
                    showOuterBorder={false}
                    showTableData={false}
                    yAxisTicksCount={2}
                    yAxisWidth={75}
                  />
                ) : (
                  <div>
                    <NoTrendToDisplay></NoTrendToDisplay>
                  </div>
                )}
              </td>
            }
          </tr>
        );
      });
    } else {
      selectedInstrumentDetail.allDirections.forEach((elems: any, key: number) => {
        items.push(
          <React.Fragment>
            <br />
            <span
              style={{
                cursor: "pointer",
                fontWeight:
                  this.state.activeDirectionIndx.includes(elems.id)
                    ? "bold"
                    : "normal",
                fontSize:
                  this.state.activeDirectionIndx.includes(elems.id) ? "16px" : "14px",
              }}
              id="directionRow"
              onClick={() => this.onSetActiveDirectionIndx(elems.id)}
            >
              {this.state.activeDirectionIndx.includes(elems.id) ? (
                <Icon className="mr-3" name={ABB_CARET_DOWN} />
              ) : (
                <Icon className="mr-3" name={ABB_CARET_UP} />
              )}
              <b style={{ marginRight: "10px" }}>{elems.name}</b>
            </span>
          </React.Fragment>
        );
        let newrow = key;

        this.state.activeDirectionIndx.includes(elems.id) &&
          filteredProps
            .filter((elements: any) => elements.directionId === elems.id)
            .forEach((property: any, index: any) => {
              let meanV;
              if (selectedInstrumentDetail?.readings?.length > 0) {
                const filterReadings = selectedInstrumentDetail.readings.find((x: any) => x.propertyId === property.id &&
                  x.directionId === property.directionId);
                meanV = filterReadings
                  ? filterReadings.directionMeans.find(
                    (x: any) =>
                      x.propertyId === property.id &&
                      x.directionId === property.directionId
                  )
                  : undefined;
              }
              const dirCount =
                this.props.selectedInstrumentDetail.directionCounts.find(
                  (x: any) => x.name === countData?.positionName
                );
              var allValueRangesForAPosition: any[] = [];
              this.props.selectedInstrumentDetail.readings.forEach((x: any) => {
                if (dirCount !== undefined) {
                  if (
                    x.propertyId === property.id &&
                    x.positionName === dirCount.name &&
                    x.position === index
                  ) {
                    allValueRangesForAPosition.push(x);
                  }
                }
              });
              const meanVal = (meanV === undefined || meanV.mean === 0) ? "(--)" : meanV.mean;
              const meanValue = Math.round(Number(meanVal) * 100) / 100;

              const trendData = [];
              let propertyDetails: any = {};

              selectedInstrumentDetail?.statistics
                ?.sort(utility.sortAlphaNum)
                .forEach((item: any) => {
                  if (
                    property.id === item.propertyId &&
                    property.directionId === item.directionId
                  ) {
                    propertyDetails = filteredProps.find(
                      (x) => item.propertyId === x.id
                    );
                    trendData.push({
                      xValue: item.positionName
                        ? item.positionName
                        : item.position.toString(),
                      value: item.mean != null ? item.mean : 0,
                    });
                  }
                });
              if (trendData.length !== 0) {
                  trendData.push({ xValue: "", value: null });
              }
              const yValue: number[] = [
                propertyDetails.alarmLow1,
                propertyDetails.alarmLow2,
                propertyDetails.alarmHigh1,
                propertyDetails.alarmHigh2,
                propertyDetails.rejectLow,
                propertyDetails.rejectHigh,
              ];
              trendData.sort(utility.sortAlphaNum).forEach((item: any) => {
                yValue.push(item.value);
              });

              let minYValue: any = 0;
              let maxYValue: any = 0;

              if (Math.sign(_.min(yValue)) === -1) {
                minYValue = _.min(yValue) + (_.min(yValue) / 100) * 5;
                maxYValue = _.max(yValue) - (_.max(yValue) / 100) * 5;
              } else {
                // ITC Changes
                minYValue = _.min(yValue) - (_.min(yValue) / 100) * 5;
                // const minYValue: any = 0;
                maxYValue = _.max(yValue) + (_.max(yValue) / 100) * 5;
              }

              const series1: ISeries[] = [
                {
                  name: "Mean",
                  color: "#5ABFAE",
                  id: "1",
                  markerStyle: {
                    type: this.state?.chartType ==="Bar" ? "None" : "Circle",
                  },
                  yAxis: {
                    min: minYValue,
                    max: maxYValue,
                    decimalPlaces: propertyDetails?.decimals,
                  },
                  dataLimits: [
                    {
                      name: "Alarm Low Limit-1",
                      shownInChart: this.state.thresholdSettings?.find(
                        (x: any) =>
                          x.name === "Alarm Low 1" || x.name === "Alarm Limit1"
                      ).isActive,
                      value: propertyDetails.alarmLow1,
                      className: "custom-line-graph",
                      style: {
                        stroke: this.state.thresholdSettings?.find(
                          (x: any) =>
                            x.name === "Alarm Low 1" || x.name === "Alarm Limit1"
                        ).colorCode,
                      },
                    },
                    {
                      name: "Alarm High Limit-1",
                      shownInChart: this.state.thresholdSettings?.find(
                        (x: any) =>
                          x.name === "Alarm High 1" || x.name === "Alarm Limit1"
                      ).isActive,
                      value: propertyDetails.alarmHigh1,
                      className: "custom-line-graph",
                      style: {
                        stroke: this.state.thresholdSettings?.find(
                          (x: any) =>
                            x.name === "Alarm High 1" || x.name === "Alarm Limit1"
                        ).colorCode,
                      },
                    },
                    {
                      name: "Alarm Low Limit-2",
                      shownInChart: this.state.thresholdSettings?.find(
                        (x: any) =>
                          x.name === "Alarm Low 2" || x.name === "Alarm Limit2"
                      ).isActive,
                      value: propertyDetails.alarmLow2,
                      className: "custom-line-graph",
                      style: {
                        stroke: this.state.thresholdSettings?.find(
                          (x: any) =>
                            x.name === "Alarm Low 2" || x.name === "Alarm Limit2"
                        ).colorCode,
                      },
                    },
                    {
                      name: "Alarm High Limit-2",
                      shownInChart: this.state.thresholdSettings?.find(
                        (x: any) =>
                          x.name === "Alarm High 2" || x.name === "Alarm Limit2"
                      ).isActive,
                      value: propertyDetails.alarmHigh2,
                      className: "custom-line-graph",
                      style: {
                        stroke: this.state.thresholdSettings?.find(
                          (x: any) =>
                            x.name === "Alarm High 2" || x.name === "Alarm Limit2"
                        ).colorCode,
                      },
                    },
                    {
                      name: "Reject Low",
                      shownInChart: this.state.thresholdSettings?.find(
                        (x: any) =>
                          x.name === "Reject Low" || x.name === "Reject Limit"
                      ).isActive,
                      value: propertyDetails.rejectLow,
                      className: "custom-line-graph",
                      style: {
                        stroke: this.state.thresholdSettings?.find(
                          (x: any) =>
                            x.name === "Reject Low" || x.name === "Reject Limit"
                        ).colorCode,
                      },
                    },
                    {
                      name: "Reject High",
                      shownInChart: this.state.thresholdSettings?.find(
                        (x: any) =>
                          x.name === "Reject High" || x.name === "Reject Limit"
                      ).isActive,
                      value: propertyDetails.rejectHigh,
                      className: "custom-line-graph",
                      style: {
                        stroke: this.state.thresholdSettings?.find(
                          (x: any) =>
                            x.name === "Reject High" || x.name === "Reject Limit"
                        ).colorCode,
                      },
                    },
                  ],
                  isShownInChart: true,
                  points: trendData,
                },
              ];

              items.push(
                <tr
                  key={key + "-" + index}
                  style={key === newrow ? { borderTop: "2px solid #1f1f1f" } : {}}
                >
                  <td className="instrument" style={{ padding: "0px" }}>
                    <table className="innerTable ins-mesurement">
                      <tr style={{ background: "none" }}>
                        <td className="title" style={{ paddingBottom: "114px" }}>
                          <span className="row pl-0 pr-0">
                            <span className="col-7 pl-0">{property.name}</span>
                            <span className="col-1 pl-0">{property.unit}</span>
                            <span className="col-4 pl-0">
                              {isNaN(meanValue) || meanValue === null || meanValue === undefined ? (
                                <span
                                  className="val"
                                  style={{
                                    color: CONSTANTS.WITHIN_LIMIT_COLOR
                                  }}
                                >
                                  {CONSTANTS.NOTCONSIDEREDFORCALC}
                                </span>
                              ) : (
                                <span
                                  className="val"
                                  style={{
                                    color: CONSTANTS.WITHIN_LIMIT_COLOR
                                  }}
                                >
                                  ({meanValue?.toFixed(property?.decimals)})
                                </span>
                              )}
                            </span>
                          </span>
                        </td>
                      </tr>
                    </table>
                  </td>
                  {
                    <td
                      className="trend-table"
                      colSpan={selectedInstrumentDetail.countData.length}
                    >
                      {series1[0].points?.length > 0 ? (
                        <Trend
                          chartType={this.state.chartType}
                          invalidPointLineType="None"
                          invalidStatuses={["Invalid"]}
                          dateUnit={this.state.dateUnit}
                          dateUnitCount={this.state.dateUnitCount}
                          gridLineColor="grey"
                          gridLineWidth={0.5}
                          showVerticalGridLines={false}
                          showHorizontalGridLines={true}
                          series={series1}
                          xAxis={{ type: "Ordinal", tickAngle: 45, height: 60 }}
                          onChartTypeChange={this.onChartTypeChange}
                          onDataLimitVisibilityChange={
                            this.onDataLimitVisibilityChange
                          }
                          onDateRangeChange={this.onDateRangeChange}
                          onInvalidPointTypeChange={this.onInvalidPointTypeChange}
                          onSeriesChartTypeChange={this.onSeriesChartTypeChange}
                          onSeriesColorChange={this.onSeriesColorChange}
                          onSeriesFillTypeChange={this.onSeriesFillTypeChange}
                          onSeriesMarkerChange={this.onSeriesMarkerChange}
                          trendChartHeight={150}
                          showChartType={false}
                          showDateTimePicker={false}
                          showOuterBorder={false}
                          showTableData={false}
                          yAxisTicksCount={2}
                          yAxisWidth={75}
                        />
                      ) : (
                        <div>
                          <NoTrendToDisplay></NoTrendToDisplay>
                        </div>
                      )}
                    </td>
                  }
                </tr>
              );
              newrow += 1;
            });
      });
    }
    return items;
  }

  toggleGraphView = () => {
    this.setState({
      toggleGraph: !this.state.toggleGraph,
      thresholdSettings: (this.state.thresholdSettings || []).map((element) => {
        return { ...element, isActive: true };
      }),
    });
  };


  componentWillReceiveProps(nextProps: Readonly<Iprops>, nextContext: any): void {
    if (
      nextProps.selectedInstrumentDetail &&
      nextProps.selectedInstrumentDetail.nextMeasuringPositionDireaction &&
      nextProps.selectedInstrumentDetail.nextMeasuringPositionDireaction
        .directionId
    ) {
      if (
        this.state.activeDirectionIndx &&
        (this.state.activeDirectionIndx.length > 1 ||
          !this.state.activeDirectionIndx.includes(
            nextProps.selectedInstrumentDetail.nextMeasuringPositionDireaction
              .directionId
          ))
      ) {
        this.setState({
          activeDirectionIndx: [
            nextProps.selectedInstrumentDetail.nextMeasuringPositionDireaction
              .directionId,
          ],
        });
      }
    }
  }

  componentDidMount() {
    const activeDirectionIndx: any = [];
    if (
      this.props.selectedInstrumentDetail &&
      this.props.selectedInstrumentDetail.nextMeasuringPositionDireaction &&
      this.props.selectedInstrumentDetail.nextMeasuringPositionDireaction
        .directionId
    ) {

      activeDirectionIndx.push(
        this.props.selectedInstrumentDetail.nextMeasuringPositionDireaction
          .directionId
      );
      this.setState({ activeDirectionIndx });
      const directionHeight = window.document.getElementById("directionRow");
      const indexVal =
        this.props.selectedInstrumentDetail.allDirections.findIndex(
          (el: any) =>
            el.id ===
            this.props.selectedInstrumentDetail.nextMeasuringPositionDireaction
              .directionId
        );
      if (directionHeight && indexVal > -1) {
        const scrollVal = indexVal * directionHeight.offsetHeight;
        const element = window.document.getElementById("tableScroll");
        setTimeout(() => {
          element.scrollTop = scrollVal + 30;
        }, 500);
      }
    }
    else if(activeDirectionIndx && activeDirectionIndx?.length <= 0){
      activeDirectionIndx.push(this.props.selectedInstrumentDetail?.allDirections[0]?.id);
    }
    this.setState({ activeDirectionIndx });
    if (this.props.thresholdSettings) {
      this.setState({
        thresholdSettings: this.props.thresholdSettings,
        chartType: measurementSettingStore.getChartType(),
      });
    }

  }

  render() {
    let isClickDiable: boolean = false;
    if (this.props?.selectedInstrumentDetail?.instrumentSampleStatus && this.props?.selectedInstrumentDetail?.instrumentSampleStatus?.name === "In Use" && this.props?.selectedInstrumentDetail?.status?.name === Status.STOPPED) {
      isClickDiable = true
    }
    let tooltipText = ""
    if (this.props.selectedInstrumentDetail?.status?.name === Status.PENDING ||
      this.props.selectedInstrumentDetail?.status?.name === Status.AVAILABLE) {
      tooltipText = CONSTANTS.BUTTON_START;
    } else if (this.props.selectedInstrumentDetail?.status?.name === Status.INUSE) {
      tooltipText = CONSTANTS.BUTTON_START;
    } else if (this.props.selectedInstrumentDetail?.status?.name === Status.MEASURING) {
      tooltipText = CONSTANTS.BUTTON_STOP;
    } else if (this.props.selectedInstrumentDetail?.status?.name === Status.PAUSED ||
      this.props.selectedInstrumentDetail?.status?.name === Status.STOPPED) {
      tooltipText = CONSTANTS.BUTTON_REMEASURE;
    } else if (this.props.selectedInstrumentDetail?.status?.name === Status.COMPLETED) {
      tooltipText = CONSTANTS.BUTTON_REMEASURE;
    } else if (this.props.selectedInstrumentDetail?.status?.name === Status.WAITING) {
      tooltipText = CONSTANTS.BUTTON_WAITING;
    } else {
      tooltipText = CONSTANTS.BUTTON_REMEASURE;
    }
    return (
      <Translation>
        {(t) => (
          <React.Fragment>

            <div className="col-12">
              <button
                title="back"
                className="icon-button circle "
                onClick={(e: any) => { this.props.showDashboardDetails(1) }}
              >
                <Icon name="abb/left" sizeClass="small" />
              </button>
              <b className="instrument-name-in-property">{this.props.selectedInstrumentDetail?.name ?? ''} <span style={{ fontSize: '12px' }}>{this.props.selectedInstrumentDetail.testPlan && this.props.selectedInstrumentDetail.testPlan.isPDC ? "(P->D->C)" : "(D->P->C)"}</span></b>
              <ul className="navbar-nav propertyFilterList">
                <li className="position-relative">
                  <button title="search" className="searchIcon icon-button">
                    <Icon name="abb/search" sizeClass="small" />
                  </button>
                  <input
                    type="text"
                    className="searchInput"
                    placeholder={t(CONSTANTS.LABEL_SEARCH)}
                    value={this.state.searchValue}
                    onChange={this.searchHandler}
                  />
                </li>
                <li>
                  {this.state.toggleGraph ? (
                    <button
                      title={t(CONSTANTS.TITLE_TESTOVERVIEW_DETAILS)}
                      className={
                        this.state.toggleGraph
                          ? "icon-button circle active"
                          : "icon-button circle"
                      }
                      onClick={this.toggleGraphView}
                    >
                      <Icon name="abb/list" sizeClass="small" />
                    </button>
                  ) : (
                    <button
                      title={t(CONSTANTS.TITLE_TESTOVERVIEW_GRAPH)}
                      className={
                        this.state.toggleGraph
                          ? "icon-button circle active"
                          : "icon-button circle"
                      }
                      onClick={this.toggleGraphView}
                    >
                      <Icon name="abb/trend-3" sizeClass="small" />
                    </button>
                  )}
                </li>
              </ul>
              <div className="divider"></div>
              <div className="table-data-container" id="tableScroll">
                <table className="table propertyTable table-striped">
                  <thead>
                    <tr>
                      <th className="instrument">
                        <div className="measureItems">
                          <button
                            title={tooltipText}
                            className="icon-button circle btn-40 m-0"
                          >
                            {this.props.selectedInstrumentDetail.status &&
                              (this.props.selectedInstrumentDetail.status
                                ?.name === Status.PENDING ||
                                this.props.selectedInstrumentDetail.status
                                  ?.name === Status.AVAILABLE) && (
                                <Icon
                                  name={
                                    this.props.selectedInstrumentDetail
                                      .iconStatus?.name
                                  }
                                  sizeClass="small"
                                  onClick={(e: any) =>
                                    !isClickDiable && this.props.startInstrumentMeasurement(
                                      e,
                                      this.props.selectedInstrumentDetail.id
                                    )
                                  }
                                  className={
                                    isClickDiable
                                      ? "iconDisabled"
                                      : ""
                                  }
                                />
                              )}
                            {this.props.selectedInstrumentDetail.status &&
                              this.props.selectedInstrumentDetail.status
                                ?.name === Status.WAITING && (
                                <Icon
                                  name={
                                    this.props.selectedInstrumentDetail
                                      .iconStatus?.name
                                  }
                                  sizeClass="small"
                                  onClick={(e: any) =>
                                    !isClickDiable && this.props.startInstrumentMeasurement(
                                      e,
                                      this.props.selectedInstrumentDetail.id
                                    )
                                  }
                                  className={
                                    isClickDiable
                                      ? "iconDisabled"
                                      : ""
                                  }
                                />
                              )}
                            {this.props.selectedInstrumentDetail.status &&
                              this.props.selectedInstrumentDetail.status
                                ?.name === Status.MEASURING && (
                                <Icon
                                  name={
                                    this.props.selectedInstrumentDetail
                                      .iconStatus?.name
                                  }
                                  sizeClass="small"
                                  onClick={(e: any) =>
                                    !isClickDiable && this.props.stopInstrumentMeasurement(
                                      e,
                                      this.props.selectedInstrumentDetail.id
                                    )
                                  }
                                  className={
                                    isClickDiable
                                      ? "iconDisabled"
                                      : ""
                                  }
                                />
                              )}
                            {this.props.selectedInstrumentDetail.status &&
                              (this.props.selectedInstrumentDetail.status
                                ?.name === Status.PAUSED ||
                                this.props.selectedInstrumentDetail.status
                                  .name === Status.STOPPED) && (
                                <Icon
                                  name={
                                    this.props.selectedInstrumentDetail
                                      .iconStatus?.name
                                  }
                                  sizeClass="small"
                                  onClick={(e: any) =>
                                    !isClickDiable && this.props.remeasureInstrumentMeasurement(
                                      e,
                                      this.props.selectedInstrumentDetail.id
                                    )
                                  }
                                  className={
                                    isClickDiable
                                      ? "iconDisabled"
                                      : ""
                                  }
                                />
                              )}
                            {this.props.selectedInstrumentDetail.status &&
                              this.props.selectedInstrumentDetail.status
                                ?.name === Status.COMPLETED && (
                                <Icon
                                  name={
                                    this.props.selectedInstrumentDetail
                                      .iconStatus?.name
                                  }
                                  sizeClass="small"
                                  onClick={(e: any) =>
                                    !isClickDiable && this.props.remeasureInstrumentMeasurement(
                                      e,
                                      this.props.selectedInstrumentDetail.id
                                    )
                                  }
                                  className={
                                    isClickDiable
                                      ? "iconDisabled"
                                      : ""
                                  }
                                />
                              )}
                          </button>
                          <div className="details">
                            <p className="title">
                              {this.props.selectedInstrumentDetail.name}
                            </p>
                            <p>
                              {
                                (this.props.selectedInstrumentDetail.count
                                  .totalCount && this.props.selectedInstrumentDetail.count
                                    .completedCounts ===
                                  this.props.selectedInstrumentDetail.count
                                    .totalCounts) || this.props.selectedInstrumentDetail
                                      .status.name === Status.COMPLETED ? (
                                  <p className="statusGreen">
                                    {t(Status.COMPLETED)}
                                  </p>
                                ) : this.props.selectedInstrumentDetail
                                  .status.name === Status.NOTMEASURED || this.props.selectedInstrumentDetail
                                    .status.name === Status.AVAILABLE ? (
                                  <p className="statusGray">
                                    {t(Status.AVAILABLE)}
                                  </p>
                                ) : this.props.selectedInstrumentDetail
                                  .status.name === Status.STOPPED ? (
                                  <p className="statusGray">
                                    {t(Status.STOPPED)}
                                  </p>
                                ) : this.props.selectedInstrumentDetail
                                  .status.name === Status.MEASURING ? (
                                  <p className="statusGray">
                                    {t(Status.MEASURING)}
                                  </p>
                                ) : this.props.selectedInstrumentDetail
                                  .status.name === Status.PENDING ? (
                                  <p className="statusGray">
                                    {t(Status.PENDING)}
                                  </p>
                                ) : <></>}
                            </p>
                            <p>
                              {
                                this.props.selectedInstrumentDetail.count
                                  .completedCounts
                              }{" "}
                              (
                              {
                                this.props.selectedInstrumentDetail.count
                                  .totalCounts
                              }
                              )
                            </p>
                          </div>
                          <progress
                            value={
                              this.props.selectedInstrumentDetail.count
                                .completedCounts
                            }
                            max={
                              this.props.selectedInstrumentDetail.count
                                .totalCounts
                            }
                          >
                            {" "}
                            {
                              this.props.selectedInstrumentDetail
                                .completionPercentage
                            }{" "}
                          </progress>
                        </div>
                      </th>
                      {this.createMeasuredDashboard()}
                    </tr>

                    {this.state.toggleGraph ? (<tr className="legend-sticky">
                      <th
                        colSpan={
                          this.props.selectedInstrumentDetail &&
                            this.props.selectedInstrumentDetail.countData
                            ? this.props.selectedInstrumentDetail.countData
                              .length + 1
                            : 1
                        }
                      >
                        {this.colorDisplay()}
                      </th>
                    </tr>) : <></>}
                  </thead>
                  {!this.state.toggleGraph ? (
                    <tbody>{this.measuredRow()}</tbody>
                  ) : (
                    <tbody>{this.graphRowDetails()}</tbody>
                  )}
                </table>
              </div>
            </div>

          </React.Fragment>
        )}
      </Translation>
    );
  }
}
